import useBellaCookies, { Set } from '../useBellaCookies';

export const CLUB_REGISTRATION_COOKIE = 'was_club_registration_overlay_shown';

const useWasClubRegistrationViewed = (): [boolean, Set] => {
    const [status, setStatus] = useBellaCookies(CLUB_REGISTRATION_COOKIE, true);

    const hasBeenViewed = !!status;

    return [hasBeenViewed, setStatus];
};

export default useWasClubRegistrationViewed;
